import clsx from "clsx";
import { useLocale } from "hooks";
import translation from "./translation";
import {
  TelegramShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";
import { toast } from "react-toastify";
import { useEffect, type Dispatch, type FC, type SetStateAction } from "react";
import axios from "axios";
import { useRouter } from "next/router";
import Link from "next/link";
interface IProps {
  shareLink: string;
  setShareLink: Dispatch<SetStateAction<string>>;
  classNAme?: string;
  videosButton: Object;
  shouldHideVideosButtonLink: boolean;
}

const Sharing: FC<IProps> = ({
  shareLink,
  className,
  setShareLink,
  videosButton,
  shouldHideVideosButtonLink,
}) => {
  const router = useRouter();
  useEffect(() => {
    const getTinyLink = async () => {
      try {
        const resp = await axios.post("/api/tiny-link", {
          url: window.location.href,
        });
        setShareLink(resp.data);
        if (typeof resp.data !== "string") throw new Error("خطا");
      } catch (error) {
        console.log(error);
        setShareLink(window.location.href);
      }
    };
    getTinyLink();
  }, [router.asPath]);

  function unsecuredCopyToClipboard(text: string) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.prepend(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      toast.success(translation[locale]?.COPIED);
    } catch (err) {
      console.error("Unable to copy to clipboard", err);
    }
    document.body.removeChild(textArea);
  }

  const copyToClipboard = async () => {
    if (navigator.clipboard) {
      // If normal copy method available, use it
      await navigator.clipboard.writeText(shareLink);
      toast.success(translation[locale]?.COPIED);
    } else {
      // Otherwise fallback to the above function
      unsecuredCopyToClipboard(shareLink);
    }
  };

  const { isRTL, locale } = useLocale();
  return (
    <div>
      <div className={className ? className : "tw-text-[#344456] tw-flex"}>
        <div className="tw-flex tw-items-center tw-font-medium sm:tw-m-auto print:tw-hidden tw-justify-center md:tw-justify-start tw-w-full md:tw-w-auto xxxl:tw-text-[18.61px]">
          <span>{translation[locale]?.SHARE} :</span>
          <div
            className={clsx("tw-flex tw-pt-2", {
              "tw-mr-4 sm:tw-mr-8": isRTL,
              "tw-ml-4 sm:tw-ml-8": !isRTL,
            })}
          >
            <TelegramShareButton url={shareLink}>
              <a target="_blank" className="tw-group">
                <svg
                  width="22"
                  height="21"
                  viewBox="0 0 22 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="tw-fill-[#344456]/50 hover:tw-fill-[#0088cc]"
                >
                  <path d="M21.1456 1.14492C20.7856 0.839645 20.2202 0.795965 19.6355 1.03068H19.6346C19.0197 1.2774 2.22928 8.47932 1.54576 8.77356C1.42144 8.81676 0.335681 9.22189 0.447521 10.1243C0.547361 10.9379 1.42 11.2748 1.52656 11.3137L5.7952 12.7753C6.0784 13.718 7.1224 17.1961 7.35328 17.9392C7.49728 18.4024 7.732 19.011 8.14336 19.1363C8.50432 19.2755 8.86336 19.1483 9.09568 18.9659L11.7054 16.5452L15.9184 19.8308L16.0187 19.8908C16.3048 20.0176 16.5789 20.0809 16.8405 20.0809C17.0426 20.0809 17.2365 20.043 17.4218 19.9672C18.053 19.708 18.3054 19.1065 18.3318 19.0384L21.4787 2.6814C21.6707 1.8078 21.4038 1.36332 21.1456 1.14492ZM9.55984 13.36L8.11984 17.2L6.67984 12.4L17.7198 4.23996L9.55984 13.36Z" />
                </svg>
              </a>
            </TelegramShareButton>

            <LinkedinShareButton
              url={shareLink}
              className={clsx("tw-group", {
                "tw-mr-5 first:tw-mr-0": isRTL,
                "tw-ml-5 first:tw-ml-0": !isRTL,
              })}
            >
              <a target="_blank">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="tw-fill-[#344456]/50 group-hover:tw-fill-[#0A66C2]"
                >
                  <g clipPath="url(#clip1_790_3942)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.53765 0.79248H15.5556C16.758 0.795932 17.9101 1.27511 18.7603 2.12534C19.6106 2.97557 20.0898 4.12773 20.0932 5.33013V16.2565C20.0893 17.4586 19.61 18.6103 18.7598 19.4602C17.9096 20.3101 16.7577 20.789 15.5556 20.7925H4.53765C3.33553 20.789 2.18362 20.3101 1.33343 19.4602C0.483254 18.6103 0.00388261 17.4586 0 16.2565V5.33013C0.00345147 4.12773 0.482632 2.97557 1.33286 2.12534C2.18309 1.27511 3.33525 0.795932 4.53765 0.79248V0.79248Z"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.04351 8.54489H10.583V9.85304H10.6189C10.9738 9.21858 11.8371 8.54489 13.1273 8.54489C15.8074 8.54489 16.3028 10.2128 16.3028 12.3827V16.971H13.6555V12.8929C13.6555 11.9592 13.6359 10.7573 12.2786 10.7573C10.9214 10.7573 10.6892 11.7727 10.6892 12.8258V16.9792H8.04351V8.54489ZM6.54077 5.99072C6.54077 6.26303 6.46002 6.52923 6.30873 6.75565C6.15744 6.98206 5.94241 7.15854 5.69083 7.26274C5.43925 7.36695 5.16241 7.39422 4.89533 7.34109C4.62825 7.28797 4.38293 7.15684 4.19037 6.96429C3.99782 6.77173 3.86669 6.52641 3.81357 6.25933C3.76044 5.99225 3.78771 5.71541 3.89191 5.46383C3.99612 5.21225 4.1726 4.99722 4.39901 4.84593C4.62543 4.69464 4.89163 4.61389 5.16394 4.61389C5.52896 4.61432 5.87891 4.75952 6.13703 5.01763C6.39514 5.27575 6.54034 5.6257 6.54077 5.99072V5.99072ZM3.79038 8.54489H6.54077V16.971H3.79038V8.54489Z"
                      className="tw-fill-white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip1_790_3942">
                      <rect
                        width="20.0932"
                        height="20"
                        fill="white"
                        transform="translate(0 0.79248)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </LinkedinShareButton>
            <WhatsappShareButton
              url={shareLink}
              className={clsx("tw-group", {
                "tw-mr-5 first:tw-mr-0": isRTL,
                "tw-ml-5 first:tw-ml-0": !isRTL,
              })}
            >
              <a target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="tw-fill-[#344456]/50"
                >
                  <rect
                    width="24"
                    height="24"
                    rx="5"
                    fill="url(#paint1_linear_1499_7853)"
                  />
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V19C24 21.7614 21.7614 24 19 24H5C2.23858 24 0 21.7614 0 19V5Z"
                    className="tw-fill-[#344456]/50 group-hover:tw-fill-zero"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.0472 5.91684C16.4426 4.31035 14.3087 3.42525 12.0352 3.42427C7.35064 3.42427 3.53795 7.23671 3.53607 11.9227C3.53549 13.4206 3.92677 14.8827 4.67057 16.1717L3.46484 20.5757L7.9703 19.3939C9.21168 20.0709 10.6093 20.4279 12.0317 20.4284H12.0353C16.7193 20.4284 20.5323 16.6154 20.5343 11.9293C20.5351 9.65855 19.6518 7.52324 18.0472 5.91684ZM12.0353 18.993H12.0324C10.7649 18.9925 9.52159 18.652 8.43706 18.0083L8.17907 17.8553L5.50546 18.5566L6.21908 15.9499L6.05112 15.6825C5.34404 14.5579 4.97051 13.258 4.97108 11.9231C4.97263 8.02835 8.14153 4.85969 12.0381 4.85969C13.9248 4.86035 15.6985 5.59605 17.0322 6.93138C18.3659 8.26663 19.0999 10.0414 19.0992 11.9289C19.0976 15.8241 15.9287 18.993 12.0353 18.993ZM15.91 13.7023C15.6976 13.5961 14.6537 13.0823 14.459 13.0114C14.2644 12.9407 14.1227 12.9052 13.9812 13.1178C13.8396 13.3304 13.4326 13.8087 13.3087 13.9505C13.1848 14.0921 13.0609 14.11 12.8486 14.0036C12.6362 13.8973 11.952 13.673 11.1408 12.9495C10.5096 12.3865 10.0834 11.6911 9.95948 11.4784C9.8356 11.2658 9.94623 11.1509 10.0526 11.045C10.1481 10.9498 10.265 10.7969 10.3712 10.6729C10.4774 10.549 10.5127 10.4603 10.5836 10.3186C10.6544 10.1769 10.619 10.0528 10.5658 9.94663C10.5127 9.84024 10.088 8.79495 9.91107 8.36974C9.7387 7.95573 9.56362 8.01175 9.43328 8.0052C9.30956 7.99907 9.16785 7.99768 9.02622 7.99768C8.88467 7.99768 8.65465 8.05083 8.45995 8.26344C8.26533 8.47605 7.71673 8.98982 7.71673 10.0351C7.71673 11.0804 8.47761 12.0901 8.58384 12.2319C8.68997 12.3736 10.0813 14.5186 12.2116 15.4385C12.7181 15.6573 13.1137 15.7879 13.4222 15.8859C13.931 16.0475 14.3939 16.0246 14.7597 15.97C15.1678 15.909 16.0161 15.4562 16.1931 14.9602C16.3701 14.4641 16.3701 14.0389 16.317 13.9503C16.2639 13.8619 16.1224 13.8087 15.91 13.7023Z"
                    className="tw-fill-white"
                  />
                  <defs>
                    <linearGradient
                      className="tw-hidden group-hover:tw-block"
                      id="paint1_linear_1499_7853"
                      x1="18.2749"
                      y1="-4.38058e-07"
                      x2="6.82169"
                      y2="24"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#61FD7D" />
                      <stop offset="1" stopColor="#27D045" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            </WhatsappShareButton>
            <div
              rel="noreferrer"
              target="_blank"
              onClick={copyToClipboard}
              className={clsx("tw-group tw-cursor-pointer", {
                "tw-mr-5 first:tw-mr-0": isRTL,
                "tw-ml-5 first:tw-ml-0": !isRTL,
              })}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="tw-fill-[#344456]/30 hover:tw-fill-[#344456]"
              >
                <path d="M8.82493 11.175C9.1666 11.5 9.1666 12.0333 8.82493 12.3583C8.49994 12.6833 7.9666 12.6833 7.6416 12.3583C6.0166 10.7333 6.0166 8.09166 7.6416 6.46666L10.5916 3.51666C12.2166 1.89166 14.8583 1.89166 16.4833 3.51666C18.1083 5.14166 18.1083 7.78333 16.4833 9.40833L15.2416 10.65C15.2499 9.96666 15.1416 9.28333 14.9083 8.63333L15.2999 8.23333C16.2833 7.25833 16.2833 5.675 15.2999 4.7C14.3249 3.71666 12.7416 3.71666 11.7666 4.7L8.82493 7.64166C7.8416 8.61666 7.8416 10.2 8.82493 11.175ZM11.1749 7.64166C11.4999 7.31666 12.0333 7.31666 12.3583 7.64166C13.9833 9.26666 13.9833 11.9083 12.3583 13.5333L9.40827 16.4833C7.78327 18.1083 5.1416 18.1083 3.5166 16.4833C1.8916 14.8583 1.8916 12.2167 3.5166 10.5917L4.75827 9.35C4.74994 10.0333 4.85827 10.7167 5.0916 11.375L4.69993 11.7667C3.7166 12.7417 3.7166 14.325 4.69993 15.3C5.67493 16.2833 7.25827 16.2833 8.23327 15.3L11.1749 12.3583C12.1583 11.3833 12.1583 9.8 11.1749 8.825C10.8333 8.5 10.8333 7.96666 11.1749 7.64166Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      {!shouldHideVideosButtonLink && videosButton?.[locale]?.link && (
        <Link href={videosButton?.[locale]?.link}>
          <a
            className={clsx(
              "hover:tw-bg-white hover:tw-text-[#053E6C] tw-text-white tw-text-center tw-px-11 tw-py-3 tw-flex tw-items-center tw-bg-[#113E66] tw-group tw-rounded-lg tw-border tw-border-solid hover:tw-border-[#053E6C] tw-transition-all tw-text-sm xxxl:tw-text-base tw-w-fit tw-mx-auto tw-mt-4"
            )}
          >
            <svg
              className={clsx("tw-mx-4")}
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.0013 0.666626C10.539 0.666626 11.7757 0.666626 12.7847 0.739817L9.91681 5.04165H6.00246L8.91914 0.666626H9.0013Z"
                className="tw-fill-white group-hover:tw-fill-[#053E6C]"
              />
              <path
                d="M1.88836 1.88701C2.932 0.843375 4.51959 0.692225 7.41435 0.670333L4.50015 5.04165H0.754785C0.877493 3.57157 1.17364 2.60173 1.88836 1.88701Z"
                className="tw-fill-white group-hover:tw-fill-[#053E6C]"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.667969 8.99996C0.667969 7.96934 0.667969 7.07392 0.690006 6.29165H17.3126C17.3346 7.07392 17.3346 7.96934 17.3346 8.99996C17.3346 12.9283 17.3346 14.8925 16.1142 16.1129C14.8939 17.3333 12.9297 17.3333 9.0013 17.3333C5.07293 17.3333 3.10875 17.3333 1.88836 16.1129C0.667969 14.8925 0.667969 12.9283 0.667969 8.99996ZM9.84627 9.48763C10.9496 10.1995 11.5013 10.5555 11.5013 11.0833C11.5013 11.6111 10.9496 11.967 9.84628 12.6789C8.72786 13.4006 8.16864 13.7614 7.75164 13.4965C7.33464 13.2315 7.33464 12.5155 7.33464 11.0833C7.33464 9.65112 7.33464 8.93504 7.75164 8.67011C8.16864 8.40519 8.72785 8.766 9.84627 9.48763Z"
                className="tw-fill-white group-hover:tw-fill-[#053E6C]"
              />
              <path
                d="M17.2478 5.04165C17.1251 3.57157 16.829 2.60173 16.1142 1.88701C15.6165 1.38924 14.995 1.0945 14.1669 0.919982L11.4191 5.04165H17.2478Z"
                className="tw-fill-white group-hover:tw-fill-[#053E6C]"
              />
            </svg>
            <span>{videosButton?.[locale]?.title}</span>
          </a>
        </Link>
      )}
    </div>
  );
};

export default Sharing;
